(function () {
  var SECTION_SELECTOR = '[data-section-type="instagram-feed"]';

  function ready(fn) {
    if (document.readyState !== 'loading') return fn();
    document.addEventListener('DOMContentLoaded', fn);
  }

  /* Fetch the JSON feed asset (cached by Shopify's CDN) and resolve to an
     array of posts. Resolves to [] on any failure so callers can fall back to
     the empty state without a try/catch each. */
  function fetchPosts(src) {
    if (!src || typeof fetch !== 'function') return Promise.resolve([]);
    return fetch(src, { credentials: 'omit' })
      .then(function (resp) {
        if (!resp.ok) return [];
        return resp.json();
      })
      .then(function (parsed) {
        return Array.isArray(parsed) ? parsed : [];
      })
      .catch(function () {
        return [];
      });
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function linkifyCaption(text) {
    if (!text) return '';
    var escaped = escapeHtml(text);
    escaped = escaped.replace(/(https?:\/\/[^\s<]+)/g, function (m) {
      return '<a href="' + m + '" target="_blank" rel="noopener">' + m + '</a>';
    });
    escaped = escaped.replace(/(^|\s)#([\p{L}\p{N}_]+)/gu, function (m, pre, tag) {
      return pre + '<a href="https://www.instagram.com/explore/tags/' + encodeURIComponent(tag) + '/" target="_blank" rel="noopener">#' + tag + '</a>';
    });
    escaped = escaped.replace(/(^|\s)@([A-Za-z0-9._]+)/g, function (m, pre, handle) {
      return pre + '<a href="https://www.instagram.com/' + encodeURIComponent(handle) + '/" target="_blank" rel="noopener">@' + handle + '</a>';
    });
    return escaped;
  }

  function relativeTime(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var now = new Date();
    var diffMs = now - d;
    var sec = Math.floor(diffMs / 1000);
    var min = Math.floor(sec / 60);
    var hr = Math.floor(min / 60);
    var day = Math.floor(hr / 24);
    var month = Math.floor(day / 30);
    var year = Math.floor(day / 365);
    var locale = (document.documentElement.lang || 'fr').slice(0, 2);
    var fr = locale === 'fr';
    if (sec < 60) return fr ? "à l'instant" : 'just now';
    if (min < 60) return fr ? 'il y a ' + min + ' min' : min + ' min ago';
    if (hr < 24) return fr ? 'il y a ' + hr + ' h' : hr + ' h ago';
    if (day < 30) return fr ? 'il y a ' + day + ' j' : day + ' d ago';
    if (month < 12) return fr ? 'il y a ' + month + ' mois' : month + ' mo ago';
    return fr ? 'il y a ' + year + ' an' + (year > 1 ? 's' : '') : year + ' y ago';
  }

  function buildGrid(grid, posts, limit) {
    var frag = document.createDocumentFragment();
    var carouselBadge = '<span class="ig-feed-thumb-badge" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="7" width="13" height="13" rx="2"/><path d="M4 16V6a2 2 0 0 1 2-2h10"/></svg></span>';
    var videoBadge = '<span class="ig-feed-thumb-badge" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>';
    var count = Math.min(posts.length, limit);
    for (var i = 0; i < count; i++) {
      var p = posts[i];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ig-feed-thumb';
      btn.setAttribute('data-ig-post-index', String(i));
      btn.setAttribute('aria-label', 'Open Instagram post');
      var altRaw = (p.caption || 'Instagram post').replace(/\s+/g, ' ').slice(0, 140);
      btn.innerHTML =
        '<img src="' + escapeHtml(p.thumbnail || '') + '" alt="' + escapeHtml(altRaw) + '" loading="lazy" decoding="async" width="600" height="600" referrerpolicy="no-referrer">' +
        (p.is_carousel ? carouselBadge : (p.is_video ? videoBadge : ''));
      frag.appendChild(btn);
    }
    grid.appendChild(frag);
  }

  function showEmptyState(section) {
    var carousel = section.querySelector('[data-ig-carousel]');
    var empty = section.querySelector('[data-ig-empty]');
    if (carousel) carousel.hidden = true;
    if (empty) empty.hidden = false;
  }

  /* Wire up a section once its posts have been fetched. Assumes posts is a
     non-empty array. The carousel markup starts hidden; we reveal it here so
     there's no empty flash before the data lands. */
  function buildSection(section, posts) {
    var dialog = section.querySelector('[data-ig-lightbox]');
    if (!dialog) return;
    if (typeof dialog.showModal !== 'function') { showEmptyState(section); return; }

    var carousel = section.querySelector('[data-ig-carousel]');
    if (carousel) carousel.hidden = false;

    var grid = section.querySelector('[data-ig-grid]');
    var limit = parseInt(section.getAttribute('data-post-limit'), 10) || 12;
    if (grid) buildGrid(grid, posts, limit);

    /* Carousel arrows — scroll one tile width at a time and toggle disabled
       at the ends. Touch users swipe (no arrows displayed). */
    if (carousel && grid) {
      var prevArrow = carousel.querySelector('[data-ig-scroll="-1"]');
      var nextArrow = carousel.querySelector('[data-ig-scroll="1"]');

      function tileStep() {
        var firstTile = grid.firstElementChild;
        if (!firstTile) return 0;
        var styles = getComputedStyle(grid);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return firstTile.getBoundingClientRect().width + gap;
      }

      function updateArrowState() {
        if (!prevArrow || !nextArrow) return;
        var max = grid.scrollWidth - grid.clientWidth;
        var x = grid.scrollLeft;
        prevArrow.disabled = x <= 1;
        nextArrow.disabled = x >= max - 1;
      }

      [prevArrow, nextArrow].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-ig-scroll'), 10) || 0;
          grid.scrollBy({ left: dir * tileStep(), behavior: 'smooth' });
        });
      });

      grid.addEventListener('scroll', updateArrowState, { passive: true });
      window.addEventListener('resize', updateArrowState);
      updateArrowState();
    }

    var handle = section.getAttribute('data-handle') || 'goldandskyepatterns';
    var els = {
      img: dialog.querySelector('[data-ig-media-img]'),
      videoLink: dialog.querySelector('[data-ig-video-link]'),
      caption: dialog.querySelector('[data-ig-caption]'),
      handle: dialog.querySelector('[data-ig-handle]'),
      date: dialog.querySelector('[data-ig-date]'),
      permalink: dialog.querySelector('[data-ig-permalink]'),
      dots: dialog.querySelector('[data-ig-dots]'),
      prev: dialog.querySelector('[data-ig-prev]'),
      next: dialog.querySelector('[data-ig-next]'),
      close: dialog.querySelector('[data-ig-close]'),
    };

    var state = { postIndex: 0, childIndex: 0 };
    var shareLinks = dialog.querySelectorAll('[data-ig-share]');

    function currentPost() {
      return posts[state.postIndex];
    }

    function currentMedia() {
      var post = currentPost();
      if (post.is_carousel && post.children && post.children.length > 0) {
        return post.children[state.childIndex] || post.children[0];
      }
      return { media_url: post.media_url, thumbnail_url: post.thumbnail, media_type: post.media_type };
    }

    function render() {
      var post = currentPost();
      var media = currentMedia();
      var isVideo = media.media_type === 'VIDEO';
      var nextSrc = isVideo ? (media.thumbnail_url || media.media_url) : media.media_url;
      if (els.img.getAttribute('src') !== nextSrc) {
        els.img.classList.add('is-loading'); // hide until the new image loads (no old-image flash)
        els.img.onload = function () { els.img.classList.remove('is-loading'); };
        els.img.onerror = function () { els.img.classList.remove('is-loading'); };
        els.img.src = nextSrc;
      }
      els.img.alt = (post.caption || '').slice(0, 200);
      if (isVideo) {
        els.videoLink.href = post.permalink;
        els.videoLink.hidden = false;
      } else {
        els.videoLink.hidden = true;
        els.videoLink.removeAttribute('href');
      }
      els.caption.innerHTML = linkifyCaption(post.caption);
      els.handle.textContent = '@' + handle;
      els.date.textContent = relativeTime(post.timestamp);
      els.permalink.href = post.permalink;
      updateShareLinks(post);
      renderDots(post);
    }

    function updateShareLinks(post) {
      var url = post.permalink || '';
      var caption = (post.caption || '').slice(0, 200);
      shareLinks.forEach(function (el) {
        var type = el.getAttribute('data-ig-share');
        if (type === 'facebook') {
          el.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
        } else if (type === 'x') {
          el.href = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(caption);
        } else if (type === 'email') {
          el.href = 'mailto:?subject=' + encodeURIComponent('From @' + handle) + '&body=' + encodeURIComponent(url);
        }
      });
    }

    function renderDots(post) {
      els.dots.innerHTML = '';
      if (!post.is_carousel || !post.children || post.children.length <= 1) return;
      for (var i = 0; i < post.children.length; i++) {
        var dot = document.createElement('span');
        dot.className = 'ig-lightbox-dot' + (i === state.childIndex ? ' is-active' : '');
        els.dots.appendChild(dot);
      }
    }

    function open(index) {
      state.postIndex = ((index % posts.length) + posts.length) % posts.length;
      state.childIndex = 0;
      render();
      dialog.showModal();
    }

    function goPost(delta) {
      state.postIndex = ((state.postIndex + delta) % posts.length + posts.length) % posts.length;
      state.childIndex = 0;
      render();
    }

    function navigate(delta) {
      var post = currentPost();
      if (post.is_carousel && post.children && post.children.length > 1) {
        var newChild = state.childIndex + delta;
        if (newChild >= 0 && newChild < post.children.length) {
          state.childIndex = newChild;
          render();
          return;
        }
      }
      goPost(delta);
    }

    section.querySelectorAll('[data-ig-post-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(parseInt(btn.getAttribute('data-ig-post-index'), 10) || 0);
      });
    });

    els.prev.addEventListener('click', function () { navigate(-1); });
    els.next.addEventListener('click', function () { navigate(1); });
    els.close.addEventListener('click', function () { dialog.close(); });

    dialog.addEventListener('click', function (e) {
      var card = dialog.querySelector('.ig-lightbox-card');
      if (!card.contains(e.target)) dialog.close();
    });

    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); navigate(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); navigate(1); }
    });

    shareLinks.forEach(function (el) {
      if (el.getAttribute('data-ig-share') !== 'copy') return;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var url = currentPost().permalink || '';
        if (!url || !navigator.clipboard || !navigator.clipboard.writeText) return;
        navigator.clipboard.writeText(url).then(function () {
          el.classList.add('is-copied');
          setTimeout(function () { el.classList.remove('is-copied'); }, 1500);
        });
      });
    });
  }

  /* Load the JSON asset, then build (or show the empty state). Deferred until
     the section scrolls near the viewport so we don't fetch ~200 KB of posts
     for a section the visitor may never reach. */
  function loadSection(section) {
    var src = section.getAttribute('data-ig-src');
    fetchPosts(src).then(function (posts) {
      if (Array.isArray(posts) && posts.length > 0) {
        buildSection(section, posts);
      } else {
        showEmptyState(section);
      }
    });
  }

  function setupSection(section) {
    if (section.dataset.igInitialized === '1') return;
    section.dataset.igInitialized = '1';

    if (typeof IntersectionObserver !== 'function') {
      loadSection(section);
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          obs.disconnect();
          loadSection(section);
          break;
        }
      }
    }, { rootMargin: '300px' });
    io.observe(section);
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(setupSection);
  }

  ready(init);
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) setupSection(section);
  });
})();
